import React from 'react';
import { useTranslation } from 'react-i18next';
import { Wallet } from 'lucide-react';
import { PlanDetails, ServiceType } from '../../types/api';
import { PaymentMethod } from '../../stores/subscriptionStore';
import SubscriptionPlanSection from './SubscriptionPlanSection';

interface BillingPeriodSectionProps {
  subscriptionType: 'monthly' | 'yearly' | 'trial';
  setSubscriptionType: (type: 'monthly' | 'yearly' | 'trial') => void;
  subscriptionLevel: 'standard' | 'premium';
  setSubscriptionLevel: (level: 'standard' | 'premium') => void;
  planDetails: PlanDetails | null;
  loading: boolean;
  error: string | null;
  vaseImage: string;
  paymentType: 'one_time' | 'subscription';
  setPaymentType: (type: 'one_time' | 'subscription') => void;
  selectedPaymentMethod: PaymentMethod;
  serviceType: ServiceType;
  promotionCode: string | null;
  promotionDetails: any;
  getEffectivePromotionCode: (priceBeforePromotion: number) => string | null;
}

const BillingPeriodSection: React.FC<BillingPeriodSectionProps> = ({
  subscriptionType,
  setSubscriptionType,
  subscriptionLevel,
  setSubscriptionLevel,
  planDetails,
  loading,
  error,
  vaseImage,
  paymentType,
  setPaymentType,
  selectedPaymentMethod,
  serviceType,
  promotionCode,
  promotionDetails,
  getEffectivePromotionCode
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white mt-2 rounded-xl overflow-hidden shadow-sm">
      <div className="px-5 pt-5 pb-3">
        <div className="flex items-center">
          <Wallet size={20} className="text-gray-500 mr-2" />
          <span className="text-base font-medium text-gray-900">{t('subscription.plansSection.billingPeriod')}</span>
        </div>
      </div>
      
      <div className="px-5 pb-4">
        <SubscriptionPlanSection
          subscriptionType={subscriptionType}
          setSubscriptionType={setSubscriptionType}
          subscriptionLevel={subscriptionLevel}
          setSubscriptionLevel={setSubscriptionLevel}
          planDetails={planDetails}
          loading={loading}
          error={error}
          vaseImage={vaseImage}
          displayMode="billing-period"
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          selectedPaymentMethod={selectedPaymentMethod}
          serviceType={serviceType}
          promotionCode={promotionCode || undefined}
          promotionDetails={promotionDetails}
          getEffectivePromotionCode={getEffectivePromotionCode}
        />
      </div>
    </div>
  );
};

export default BillingPeriodSection; 